/* eslint-disable import/prefer-default-export */
export enum RoleType {
  MEMBER = 'member',
  MANAGER = 'manager',
  DASHBOARD_MEMBER = 'dashboard member',
  INSIGHTS_MEMBER = 'insights member',
  JOURNEYS_MEMBER = 'journeys member',
  PROJECTS_MEMBER = 'projects member',
  RISK_ASSESSMENTS_MEMBER = 'risk assessments member',
  DAILY_LABOUR_MEMBER = 'daily labour member',
  ENGAGEMENT_MEMBER = 'engagement member',
  COMMUNITIES_MEMBER = 'communities member',
  INCIDENT_MANAGEMENT_MEMBER = 'incident management member',
  ADMIN = 'administrator',
  INSIGHTS_MANAGER = 'insights manager',
  JOURNEY_MANAGER = 'journey manager',
  PROJECT_MANAGER = 'project manager',
  RISK_MANAGER = 'risk manager',
  ENGAGEMENT_MANAGER = 'engagement manager',
  COMMUNITIES_MANAGER = 'communities manager',
  INCIDENT_MANAGER = 'incident manager',
}
